// extracted by mini-css-extract-plugin
export default {"page_title":"Title_page_title__07q1V"};